class WCProductForm extends HTMLElement {
  constructor() {
    super();
    Object.assign(this, {
      form: null,
      variantIndex: null,
      productOptionSelectors: null,
      productOptionCategories: null,
      variantInput: null,
      productJSON: null,
      variants: null,
      activeVariant: null,
      variantsData: null,
      validationInProgress: false,
      options: null,
      backgrounds: null,
      quantity: null,
      optionSelected: null,
      stickyOptionSelected: null,
      stickySelected: null,
      wcSticky: null,
      buttonContainer: null,
      variantChangeInProgress: false,
    });
  }

  get formActiveVartiant () {
    return this.activeVariant
  }

  connectedCallback() {
    this.productJSON = JSON.parse(this.dataset.productJson);

    this.wcSticky = document.querySelector('wc-product-sticky-bar');
    this.wcStickyForm = this.wcSticky?.querySelector('form');
    this.stickyOptionSelected = this.wcSticky?.querySelector('[data-selected-title]');
    this.stickySelected = this.wcSticky?.querySelector('[data-sticky-selected-swatch]');
    this.stickyProductStickyOptionSelectors = this.wcStickyForm?.querySelectorAll(
      '[data-target="options"]'
    );
    this.stickyProductStickyOptionSelectors?.forEach((selector) => {
      selector.addEventListener('change', () => {
        this.updateVariantInput(selector);
      });
    });
    this.wcStickyForm?.addEventListener(
      'submit',
      this.handleAddToBag.bind(this)
    );

    this.productOptionSelectors = this.querySelectorAll(
      '[data-target="options"]'
    );
    this.faqAnchor = this.querySelector('[href="#faq"]');
    this.optionSelected = this.querySelector('.wc-product-options__color-name');
    this.buttonContainer = this.querySelector('.wc-product-button-container');
    this.productOptionCategories = this.querySelectorAll('[data-category]');
    this.form = this.querySelector('.js-main-pdp-form');
    this.productOptionLabels = this.querySelectorAll('[data-option-category]');
    this.variantInput = this.form?.querySelector('[data-target="variant-id"]');
    this.variantIndex =
      this.form?.querySelector('[data-variant-index]:checked')?.dataset
        ?.variantIndex ?? 0;
    this.variants = this.productJSON.variants;
    this.options = this.productJSON.options;
    this.variantsData = this.productJSON.variants_display_data;
    this.backgrounds = this.productJSON.backgrounds;
    this.quantity = this.querySelector('[data-quantity-input]');

    if (this.querySelector('.wc-add-to-cart__buy-now')) {
      this.querySelector('.wc-add-to-cart__buy-now').addEventListener(
        'click',
        (e) => this.buyItNowHandle(e)
      );
    }

    document.addEventListener('variant:change', (e) => {
      this.buttonContainer?.classList.add('active');
      this.validate(e.detail.activeVariant);
      this.variantIndex = e.detail.activeVariantIndex;
    });

    this.form?.addEventListener('submit', this.handleAddToBag.bind(this));

    this.productOptionSelectors?.forEach((selector) => {
      selector.addEventListener('change', () => {
        this.updateVariantInput(selector);
      });
    });

    if (this.faqAnchor) {
      this.faqAnchor.addEventListener('click', (e) => {
        e.preventDefault();
        const faqSection = document.querySelector(
          this.faqAnchor.getAttribute('href')
        );
        if (faqSection) {
          const faqToggleMobile = document.querySelector('.js-wc-tab-faq-mobile');
          faqToggleMobile?.setAttribute('open', '');
  
          const faqToggleDesktop = document.querySelector('.js-wc-tab-faq-desktop');
          faqToggleDesktop?.dispatchEvent(new Event('click'));

          faqSection.scrollIntoView();
        }
      });
    }
    

    this.productOptionCategories?.forEach((selector) => {
      selector.addEventListener('click', () => {
        const currentActive = this.querySelector('.active[data-category]');
        currentActive.classList.remove('active');
        selector.classList.add('active');
        this.filterColor(selector.dataset.category);
      });
    });
    const formRendered = new CustomEvent('form:rendered');
    document.dispatchEvent(formRendered);

    this.querySelectorAll('.js-wc-product__accordion')
      .forEach((accGroup) => {
        const trigger = accGroup.querySelector('.js-wc-product__button')
        const content = accGroup.querySelector('.js-wc-product__content')
        if (!trigger || !content) { return }
        trigger.addEventListener('click', () => {
          accGroup.classList.toggle('open')
        })
      })

    const ingredientsWrapper = this.querySelector('.js-wc-product__ingredients')
    if (ingredientsWrapper !== null) {
      const ingredientsToggles = ingredientsWrapper.querySelectorAll('.js-wc-product__ingredients-toggle')
      ingredientsToggles.forEach(toggle => {
        toggle.addEventListener('click', (event) => {
          event.preventDefault()
          ingredientsWrapper?.classList.toggle('active');
          this.querySelector
        })
      })
    }

    this.validate();
    this.stockCheck();
  }

  stockCheck = (activeVariant) => {
    if (!activeVariant)
      activeVariant = this.activeVariant
        ? this.activeVariant
        : this.getActiveVariant();


    if (!activeVariant.available) {
      this.classList.add('pdp-oos')

      this.buttonContainer?.classList.add('oos-state');
      if (this.wcSticky) {
        this.wcSticky
          .querySelector('#add-to-cart-button-sticky')
          .classList.add('oos-state');

        const stickyAtcText = activeVariant.has_sold_out_tag
          ? this.productJSON.language.soldOut
          : this.productJSON.language.notify

        this.wcSticky.querySelector(
            '#add-to-cart-button-sticky span'
          ).textContent = stickyAtcText
      }

    } else {
      this.classList.remove('pdp-oos')

      if (this.quantity) {
        const variantQuantity = this.variantsData?.find(
          (data) => data.id === activeVariant.id
        )?.inventory_quantity ?? 100

        this.quantity.max = variantQuantity
      }

      this.buttonContainer?.classList.remove('oos-state');
      this.querySelectorAll('[data-add-to-cart1] span')?.forEach((button) => {
        button.textContent = this.productJSON.language.addToCart;
      });
      if (this.wcSticky) {
        this.wcSticky
          .querySelector('#add-to-cart-button-sticky')
          .classList.remove('oos-state');
        this.wcSticky.querySelector(
          '#add-to-cart-button-sticky span'
        ).textContent = this.productJSON.language.addToCart;
      }
    }
  };

  validate = (activeVariant) => {
    if (this.validationInProgress) return;
    this.validationInProgress = true;
    activeVariant = activeVariant ? activeVariant : this.getActiveVariant();
    this.activeVariant = activeVariant;
    const hasVariant = activeVariant !== null;
    const price = document.querySelectorAll('[data-target="product-price"]');
    let formattedVariantPrice;
    let comparePrice;
    let priceHtml;

    this.variantInput.value = activeVariant?.id;

    if (hasVariant) {
      formattedVariantPrice = `$${(activeVariant.price / 100).toFixed(0)}`;
      comparePrice = `$${(activeVariant.compare_at_price / 100).toFixed(0)}`;

      let comparePriceHtml =
        activeVariant.compare_at_price > 0
          ? `<del data-target='compare-price'>${comparePrice}</del>`
          : '';

      priceHtml = `
            <p>
                <span id="pricePlacement">${formattedVariantPrice}</span>
                ${comparePriceHtml}
            </p>`;

      if (window.location.pathname.includes('/products/')) {
        this.updateURL(activeVariant.id);
      }
    }

    price.forEach((item) => {
      const el = item;
      el.innerHTML = priceHtml;
    });

    this.stockCheck(activeVariant);
    this.validationInProgress = false;
  };

  handleAddToBag = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const activeVariant = this.getActiveVariant();
    const canAddToCart = activeVariant.available;

    if (!canAddToCart) {
      if(activeVariant.isComing) {
        this.buttonContainer?.classList.remove('active');
      } else if(activeVariant.isOos) {
        this.buttonContainer?.classList.remove('active');
      } else {
        this.buttonContainer?.classList.remove('active');
      }

      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });

      return;
    }

    const formD = new FormData(this.form);
    const sellingPlanId = formD.get('selling_plan');
    const originalProductQuantity = formD.get('quantity');

    let formData = {
      items: [
        {
          id: Number(activeVariant.id),
          quantity: originalProductQuantity,
        },
      ],
    };

    if (sellingPlanId) {
      formData.items[0].selling_plan = sellingPlanId;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        console.log('Success:', response);
        return false;
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };

  filterColor = (category) => {
    this.productOptionLabels.forEach((optionLabel) => {
      if (category === 'all') {
        optionLabel.classList.remove('hidden');
      } else {
        if (optionLabel.dataset.optionCategory === category) {
          optionLabel.classList.remove('hidden');
        } else {
          optionLabel.classList.add('hidden');
        }
      }
    });
    const firstCategorySelector = Array.from(this.productOptionLabels)
      .find((node) => node.dataset.optionCategory === category)
      .querySelector('input');
    this.updateVariantInput(firstCategorySelector);
  };

  updateURL = (variantId) => {
    if (!variantId || this.dataset.updateUrl === 'false') return;
    const url = new URL(location.href);
    url.searchParams.set('variant', variantId)
    window.history.replaceState({}, '', url);
  };

  updateVariantInput = (selector) => {
    if (this.variantChangeInProgress) return;
    this.variantChangeInProgress = true;
    // get the correct variant id, using getActiveVariant
    const selectorId = selector.getAttribute('id').replace('sticky-', '');
    document.querySelector(`#${selectorId}`).checked = true;
    const activeVariant = this.getActiveVariant();

    // set the value of the variant input to the variant id
    this.variantInput.value = activeVariant.id;

    if (this.wcSticky) {
      if (this.stickyOptionSelected) {
        this.stickyOptionSelected.textContent = activeVariant?.title;
        this.stickyOptionSelected.classList
          .toggle('variant-unavailable', activeVariant?.available === false)
      }
      if (this.stickySelected) {
        this.stickySelected.style.backgroundColor = this.backgrounds[activeVariant.id];
        this.stickySelected.classList
          .toggle('variant-unavailable', activeVariant?.available === false)
      }
      document.querySelector(`#sticky-${selectorId}`).checked = true;
    }

    if (this.optionSelected) {
      this.optionSelected.textContent = activeVariant.title;
    }

    // const matchingInputs = Array.from(
    //   document.querySelectorAll('input')
    // ).filter((input) => input.value === selector.value);
    // matchingInputs.forEach((input) => input.click());
    // trigger custom event that can be used to update the price or other elements
    document.dispatchEvent(
      new CustomEvent('variant:change', {
        bubbles: true,
        detail: { activeVariant, activeVariantIndex: activeVariant.index },
      })
    );
    this.variantChangeInProgress = false;
  };

  buyItNowHandle = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const activeVariant = this.getActiveVariant();
    const canAddToCart = activeVariant.available;

    if (!canAddToCart) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
      return;
    }

    const formData = new FormData(this.form);

    const originalProductQuantity = formData.get('quantity');

    const payload = {
      items: [
        {
          id: Number(activeVariant.id),
          quantity: originalProductQuantity,
        },
      ],
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        window.addInProgress = true;
        window.location.href = '/checkout';
        return false;
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };

  serializeForm = () => {
    const formData = new FormData(this.form);
    const serializedArray = [];

    for (const [name, value] of formData.entries()) {
      serializedArray.push({ name, value });
    }

    return serializedArray;
  };

  getActiveVariant = () => {
    const formData = this.serializeForm(this);
    const formOptions = {
      option1: null,
      option2: null,
      option3: null,
    };
    let selectedVariant = null;

    const formHasOptions = formData.some(
      (item) => item.name.indexOf('option') !== -1
    );

    if (formHasOptions) {
      formData.forEach((item) => {
        if (item.name.indexOf('option') !== -1) {
          formOptions[item.name] = item.value;
        }
      });

      this.variants.forEach((variant, index) => {
        if (
          variant.option1 === formOptions.option1 &&
          variant.option2 === formOptions.option2 &&
          variant.option3 === formOptions.option3
        ) {
          selectedVariant = variant;
          selectedVariant.index = index;
        }
      });
    } else {
      // eslint-disable-next-line prefer-destructuring
      selectedVariant = this.variants[0];
      selectedVariant.index = 0;
    }

    selectedVariant.isComing = this.variantsData.find(
      (data) => data.id === selectedVariant.id
    )?.is_coming;
    selectedVariant.isOos = this.variantsData.find(
      (data) => data.id === selectedVariant.id
    )?.is_soldout;

    return selectedVariant;
  };

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.handleAddToBag.bind(this));
    this.wcSticky.wcStickyForm.removeEventListener(
      'submit',
      this.handleAddToBag.bind(this)
    );
    // TODO: reinstate for price logic
    // this.form?.removeEventListener('change', this.validate);
    // this.form?.removeEventListener('load', this.validate);

    this.productOptionSelectors.forEach((selector) => {
      selector.removeEventListener('change', this.updateVariantInput());
    });
  }
}

if (!customElements.get('wc-product-form')) {
  customElements.define('wc-product-form', WCProductForm);
}
